/* Lightbox for image gallery */

const lightbox = function(documentElem) {

  function initLightbox() {
    const images = document.querySelectorAll(
      ':not(.carousel):not(.bannerlink) > .kg-image-card img, :not(.carousel) > .kg-gallery-card img'
    );

    images.forEach(function (image) {
      var wrapper = document.createElement('a');
      wrapper.setAttribute('data-no-swup', '');
      wrapper.setAttribute('data-fslightbox', '');
      wrapper.setAttribute('href', image.src);
      wrapper.setAttribute('aria-label', 'Click for Lightbox');
      image.parentNode.insertBefore(wrapper, image.parentNode.firstChild);
      wrapper.appendChild(image);
    });

    refreshFsLightbox();
  }

  return {
    init: initLightbox
  }
}
